<template>
    <u-select-outlined-rounded v-bind="$attrs" class="v-text-field--label-inner rounded-pill">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-outlined-rounded>
</template>

<script>
import USelectOutlinedRounded from "@/components/publish/styles/forms/u-select-outlined-rounded.vue";

export default {
    props: {},
    components: {
        USelectOutlinedRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
